import dayjs, { Dayjs } from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import { RangeValue } from 'rc-picker/lib/interface';
import { CalendarChinese } from 'date-chinese';

export function fromDdmmyyyyToMmddyyyy(date: string) {
  return date
    .split('/')
    .reduce((acc, curr, index) => {
      index === 1 ? acc.unshift(curr) : acc.push(curr);
      return acc;
    }, [] as string[])
    .join('/');
}

export const isTodayValid = (from: string, to: string): boolean => {
  const today = new Date();
  const fromDate = new Date(from);
  const toDate = new Date(to);

  return today >= fromDate && today <= toDate;
};

export const getDateInDetails = (date: Date) => {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month index from 0
  const year = date.getFullYear();

  return [hours, minutes, day, month, year] as const;
};

export function isChrismas() {
  const now = dayjs();
  const thisYear = dayjs().year();
  const daysToChrismas = now.diff(`${thisYear}-12-24`, 'day');
  return daysToChrismas <= 3 && daysToChrismas > -10;
}

export function isTet() {
  const nowDayjs = dayjs();
  const currYear = dayjs().year();
  const calendar = new CalendarChinese();
  const newYear = calendar.newYear(currYear + 1);
  calendar.fromJDE(newYear);
  const { year, month, day } = calendar.toGregorian(currYear);
  const daysToTet = nowDayjs.diff(`${year}-${month}-${day}`, 'day');
  return daysToTet <= 7 && daysToTet > -24;
}

export function getFestival() {
  if (isChrismas()) return 'chrismas';
  if (isTet()) return 'tet';
  return '';
}

export function isFestival() {
  return getFestival() !== '';
}

export function getDefaultDateRangeValue(dateRangeObj: {
  startDate: string;
  endDate: string;
}): RangeValue<Dayjs> | null {
  if (!dateRangeObj || isEmpty(dateRangeObj)) return null;
  const timeArray = Object.values(dateRangeObj) as string[];
  return timeArray.every(item => !item)
    ? null
    : (timeArray.map(date => dayjs(fromDdmmyyyyToMmddyyyy(date))) as RangeValue<Dayjs>);
}

export const fromDdmmyyyyToyyyymmdd = (stringDate: string) => {
  const date = dayjs(stringDate, 'DD/MM/YYYY');
  return dayjs(date).format('YYYY-MM-DD');
};

export const compareDate = (date1: string | Date, date2: string | Date) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  if (d1 > d2) {
    return 1;
  }

  if (d1 < d2) {
    return -1;
  }

  return 0;
};

export function toDDMMYYYY(date: string | Date) {
  return dayjs(date).format('DD/MM/YYYY');
}
